import { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext(undefined);

export const themes = {
  wise: {
    name: 'wise',
    colors: {
      primary: '#9fe870',
      primaryDark: '#163300',
      secondary: '#163300',
      background: '#ffffff',
      backgroundAlt: '#f5f7fa',
      backgroundLight: '#edefec',
      text: '#0e0f0c',
      textLight: '#4a5568',
      border: '#e2e8f0',
      accent: '#9fe870',
      cardBg: '#ffffff',
      cardHover: '#f7f9f7',
      success: '#48bb78',
      buttonText: '#163300',
      buttonHover: '#8fd660',
      overlay: 'rgba(22, 51, 0, 0.05)'
    }
  },
  denizns: {
    name: 'denizns',
    colors: {
      primary: '#c52183',
      primaryDark: '#3d2355',
      secondary: '#3d2355',
      background: '#ffffff',
      backgroundAlt: '#f5f5f5',
      backgroundLight: '#f5f5f5',
      text: '#1a1a2e',
      textLight: '#64648c',
      border: '#e5e5e5',
      accent: '#c52183',
      cardBg: '#ffffff',
      cardHover: '#fafafa',
      success: '#10b981',
      buttonText: '#ffffff',
      buttonHover: '#a31b6d',
      overlay: 'rgba(0, 0, 0, 0.03)',
      muted: '#f5f5f5'
    }
  }
};

// Apply CSS variables to document root
const applyThemeToCSS = (themeName) => {
  const theme = themes[themeName];
  if (!theme) return;

  const root = document.documentElement;
  Object.entries(theme.colors).forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value);
  });
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState('denizns');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'denizns';
    setCurrentTheme(savedTheme);
    document.documentElement.setAttribute('data-theme', savedTheme);
    applyThemeToCSS(savedTheme);
    setIsLoading(false);
  }, []);

  const switchTheme = () => {
    const newTheme = currentTheme === 'denizns' ? 'wise' : 'denizns';
    setCurrentTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    applyThemeToCSS(newTheme);
  };

  const theme = themes[currentTheme] || themes.denizns;

  const value = {
    theme,
    currentTheme,
    switchTheme,
    isLoading
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    return {
      theme: themes.denizns,
      currentTheme: 'denizns',
      switchTheme: () => {},
      isLoading: true
    };
  }
  return context;
};
